/**
 * Clicks inside these elements must not close other modals/popups
 * (e.g. ticket popup vs AI agent panel).
 */
export const CLICK_OUTSIDE_EXCLUDED_SELECTORS = [
    '[data-cy="ai-agent"]',
    '[data-cy="account-ai-agent-fab"]',
    '.ai-agent-panel',
    '.ai-message-generator-panel',
] as const;

/**
 * The chain is an event's composed path, i.e. the target plus all of its ancestors, so each
 * node only has to be matched against the selectors - climbing with closest() would re-walk
 * ancestors that the chain already lists.
 */
export const isClickOutsideExcludedChain = (chain: readonly EventTarget[]): boolean =>
    chain.some(node => node instanceof Element && CLICK_OUTSIDE_EXCLUDED_SELECTORS.some(selector => node.matches(selector)));
